import React from 'react';

import CalendarSvg from 'assets/images/calendar.svg';

import BaseIcon from './BaseIcon';

const CalendarIcon = props => <BaseIcon {...props} src={CalendarSvg} />;

export default CalendarIcon;
